// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import VueTour from 'vue-tour';
import Vuetify from 'vuetify';
import router from './router';
import 'font-awesome/css/font-awesome.css';
import './theme/default.styl';
import './theme/assets/css/pf-ui-client.css';
import 'vue-wysiwyg/dist/vueWysiwyg.css';
import VeeValidate from 'vee-validate';
import colors from 'vuetify/es5/util/colors';
import Truncate from 'lodash.truncate';

import wysiwyg from 'vue-wysiwyg';

import { sha512 } from 'js-sha512';
import moment from 'moment-timezone';
import jQuery from 'jquery';
import swal from 'sweetalert2';
import * as filestack from 'filestack-js';
import session from './helpers/session';
import Mediator from './Mediator';
import store from './store';

const config = require('../config/config.json')[process.env.NODE_ENV];

global.moment = moment;
global.sha512 = sha512;
global.session = session;
global.moment = moment;
global.swal = swal;
global.$ = jQuery;
global.jQuery = jQuery;
global.$mclient = null;
global.store = store;
global.filestack = filestack;
global.config = config;

Vue.prototype.moment = moment;
Vue.prototype.store = store;
Vue.prototype.session = session;
Vue.prototype.Mediator = Mediator;

Vue.config.productionTip = false;
require('vue-tour/dist/vue-tour.css');
Vue.use(VueTour);
// Helpers
// Global filters
Vue.filter('truncate', Truncate);
Vue.use(VeeValidate, { fieldsBagName: 'formFields' });
Vue.use(Vuetify, {
  // theme: {
  //   primary: colors.indigo.base, // #E53935
  //   secondary: colors.indigo.lighten4, // #FFCDD2
  //   accent: colors.indigo.base // #3F51B5
  // },
  options: {
    themeVariations: ['primary', 'secondary', 'accent'],
    extra: {
      mainToolbar: {
        color: 'primary',
      },
      sideToolbar: {
      },
      sideNav: 'primary',
      mainNav: 'grey lighten-1',
      bodyBg: '',
    }
  }
});

Vue.use(wysiwyg, { maxHeight: '100%' });
// Bootstrap application components



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  Mediator,
  session,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js